import App from 'App'
import { AuthProvider } from 'context/AuthProvider'
import ReactQueryProvider from 'context/ReactQueryProvider'
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'index.css'
import { Provider } from 'react-redux'
import store from 'store'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <ReactQueryProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ReactQueryProvider>
  </Provider>,
)
